export const forgotTranslation = {
  es: {
    title: "¿Olvidaste tu contraseña?",
    subtitle: "Te enviaremos un enlace para restablecerla.",
    emailLabel: "Correo electrónico",
    emailPlaceholder: "tucorreo@ejemplo.com",
    sendButton: "Enviar enlace de recuperación",
    backToLogin: "← Volver al inicio de sesión",
    success: "Revisa tu correo para continuar.",
    error: "No se pudo enviar el correo.",
    networkError: "Error de red. Intenta más tarde.",
  },

  en: {
    title: "Forgot your password?",
    subtitle: "We will send you a link to reset it.",
    emailLabel: "Email address",
    emailPlaceholder: "yourmail@example.com",
    sendButton: "Send recovery link",
    backToLogin: "← Back to login",
    success: "Check your email to continue.",
    error: "The email could not be sent.",
    networkError: "Network error. Try again later.",
  },
};
